import keys_default from "./keys.js";
import _getSymbols_default from "./_getSymbols.js";
import _baseGetAllKeys_default from "./_baseGetAllKeys.js";

//#region ../../node_modules/lodash-es/_getAllKeys.js
/**
* Creates an array of own enumerable property names and symbols of `object`.
*
* @private
* @param {Object} object The object to query.
* @returns {Array} Returns the array of property names and symbols.
*/
function getAllKeys(object) {
	return _baseGetAllKeys_default(object, keys_default, _getSymbols_default);
}
var _getAllKeys_default = getAllKeys;

//#endregion
export { _getAllKeys_default as default };
//# sourceMappingURL=_getAllKeys.js.map